module.exports = __webpack_public_path__ + "static/media/menu-2.b89d9bef.png";